export default __webpack_public_path__ + "static/media/ic_matic_40.97ff139c.svg";